import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
  palette: {
    primary: {
      dark: '#00547D',
      main: '#0078B4',
      light: '#3393C3',
      contrastText: '#FFFFFF',
    },
  },
});
